import React, { createContext, useMemo } from 'react';
import { useCreateShoppingCart, useGetShoppingCart } from '@/hooks/GQL';
import { usePriceFreezeSession } from '@/hooks/usePriceFreezeSession';

export const RepricingContextMobile = createContext(null);

function useRepricingInfoQuery() {
  const [getSessionItem] = usePriceFreezeSession();
  const { bookingId, loading: createLoading } = useCreateShoppingCart({
    request: createSBRequestMapper(
      getSessionItem('preCreateShoppingCartRequest')
    ),
  });
  const { data, loading: getLoading } = useGetShoppingCart({
    bookingId,
  });

  return useMemo(() => {
    return {
      loading: getLoading || createLoading,
      repricing: {
        difference: {
          amount: data?.getShoppingBundle?.repricing?.difference,
        },
      },
    };
  }, [getLoading, createLoading, data]);
}

export function RepricingInfoMobile({ children }) {
  return (
    <RepricingContextMobile.Provider value={useRepricingInfoQuery()}>
      {children}
    </RepricingContextMobile.Provider>
  );
}

function createSBRequestMapper(preRequest) {
  if (!preRequest) return null;
  return {
    request: {
      searchId: String(preRequest.data.searchId),
      fareItineraryKey: preRequest.data.fareItineraryKey
        .split(',')[0]
        ?.split('_')[0],
      segmentKey: preRequest.data.segmentKeys.map(String),
      shoppingType: 'CART',
      promotedItineraryTypes: preRequest.data.promotedItineraryTypes,
      extension: preRequest.data.extensions,
    },
  };
}
